import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  ModalClose,
  ModalDialog,
  Typography,
} from "@mui/joy";
import { useNavigate } from "@tanstack/react-router";

import { useModal } from "./useModal";

export default function UnsavedChanges(_props: { uuid?: string }) {
  const { close } = useModal();
  const navigate = useNavigate();

  const discard = () => {
    navigate({
      to: "/gym/$venueUuid/events/$competitionUuid/routes",
      from: "/gym/$venueUuid/events/$competitionUuid/routes/$routeUuid",
      replace: true,
      params: (prev) => {
        const { routeUuid: _, ...params } = prev;
        return params;
      },
    });
    close();
  };

  return (
    <ModalDialog>
      <ModalClose />
      <DialogTitle>Cancel route edits?</DialogTitle>
      <DialogContent>
        <Typography sx={{ maxWidth: 350 }}>
          You have unsaved changes. Are you sure you want to leave?
        </Typography>
      </DialogContent>
      <form>
        <DialogActions>
          <Button color="danger" onClick={discard} sx={{ flex: 1 }}>
            Discard
          </Button>
          <Button color="neutral" variant="soft" onClick={close} sx={{ flex: 1 }}>
            Cancel
          </Button>
        </DialogActions>
      </form>
    </ModalDialog>
  );
}
